import { makeAutoObservable } from 'mobx';
import { ReactNode } from 'react';
import { ItemWithLabel } from '../../../components';
import Indicator from '../../../store/utils/Indicator';

const DEFAULT_LABELS = [
  'Audiodeluxe',
  'Best Service',
  'Crypton',
  'Jrr',
  'Kvr',
  'LOCKED',
  'NFR',
  'Pluginboutique',
  'Pulse Store',
  'Reverb',
  'Sweetwater',
  'Time & Space',
  'VSTBuzz',
];

const DEFAULT_LABELS_SET = new Set(DEFAULT_LABELS.map((l) => l.toLowerCase()));

export default class Labels {
  items: string[] = [];
  newLabel = '';

  isNewLabelValid = false;

  readonly indicator = new Indicator();

  constructor(
    dto: LabelsDto | undefined,
    private readonly onSave: ({ reason }: { reason?: string }) => Promise<void>,
  ) {
    makeAutoObservable(this, {}, { autoBind: true });
    if (Array.isArray(dto)) {
      this.items = dto;
    }
  }

  addNewLabel() {
    this.items.push(this.newLabel.trim());
    this.setNewLabel('');

    // noinspection JSIgnoredPromiseFromCall
    this.save();
  }

  canRemoveLabel(label: string) {
    return !DEFAULT_LABELS_SET.has(label.toLowerCase());
  }

  deleteLabel(label: string) {
    this.items = this.items.filter((l) => l !== label);

    // noinspection JSIgnoredPromiseFromCall
    this.save();
  }

  getLabelOptions(emptyText: ReactNode = 'Not set'): ItemWithLabel[] {
    const labels: ItemWithLabel[] = this.items.map((label) => {
      return { value: label, label };
    });

    if (emptyText) {
      labels.unshift({ value: '', label: emptyText });
    }

    return labels;
  }

  async save() {
    return this.indicator.spyOnPromise(this.onSave({ reason: 'labels' }));
  }

  setNewLabel(text: string) {
    this.newLabel = text;

    const trimmed = text.trim();
    this.isNewLabelValid = Boolean(trimmed && !this.items.includes(trimmed));
  }

  toJSON(): LabelsDto {
    return [...this.items];
  }
}

export type LabelsDto = string[];
